import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.body.classList.add("modal-open")
    this.onKeydown = this.onKeydown.bind(this)
    this.onBeforeCache = this.onBeforeCache.bind(this)
    document.addEventListener("keydown", this.onKeydown)
    document.addEventListener("turbo:before-cache", this.onBeforeCache)
  }

  disconnect() {
    document.body.classList.remove("modal-open")
    document.removeEventListener("keydown", this.onKeydown)
    document.removeEventListener("turbo:before-cache", this.onBeforeCache)
  }

  onKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  onBeforeCache() {
    document.body.classList.remove("modal-open")
    this.element.remove()
  }

  close(event) {
    event?.preventDefault()
    this.element.remove()
  }
}
